import { useQuery } from "@tanstack/react-query";
import agentService from "../../services/agents/agent.service";

// 0016: the SINGLE fetch of the agent list (/Agent/List). Shared by ManageAgents (the table) and
// AddOrUpdateAgent edit (which prefills by finding the agent in this list) — same queryKey, so the
// edit dialog reuses the cache with no extra network call. React Query dedups consumers + the
// StrictMode double-mount to ONE call. staleTime 60s; agent mutations (activate/permissions/delete)
// invalidate ["agents"] so the table refreshes immediately (see ManageAgentsDialogComponent).
const useAgentListQuery = ({ enabled = true } = {}) =>
  useQuery({
    queryKey: ["agents"],
    queryFn: () => agentService.getAllAgents().then((r) => r.data.payload),
    enabled,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });

export default useAgentListQuery;
